<table mat-table [dataSource]="dataSource!" matSort class="mat-elevation-z8">

    <ng-container matColumnDef="deviceName">
        <th mat-header-cell *matHeaderCellDef>Standort </th>
        <td mat-cell *matCellDef="let element"> {{element.deviceName}} </td>
    </ng-container>
    <ng-container matColumnDef="lineDescription">
        <th mat-header-cell *matHeaderCellDef> Bezeichnung </th>
        <td mat-cell *matCellDef="let element"> {{element.lineDescription}} </td>
    </ng-container>

    <ng-container matColumnDef="groupName">
        <th mat-header-cell *matHeaderCellDef> Fahrtrichtung </th>
        <td mat-cell *matCellDef="let element"> {{element.groupName}} </td>
    </ng-container>
    <ng-container matColumnDef="timestampFrom">
        <th mat-header-cell *matHeaderCellDef> Zeit (von) </th>
        <td mat-cell *matCellDef="let element"> {{element.timestampFrom | date: 'dd.MM.yyyy - H:mm:ss' }} </td>
    </ng-container>
    <ng-container matColumnDef="durationSec">
        <th mat-header-cell *matHeaderCellDef> Dauer </th>
        <td mat-cell *matCellDef="let element"> {{element.durationSec}} </td>
    </ng-container>
    <ng-container matColumnDef="height">
        <th mat-header-cell *matHeaderCellDef> Höhe [cm] </th>
        <td mat-cell *matCellDef="let element"> {{element.height}} </td>
    </ng-container>
    <ng-container matColumnDef="contentDetected">
        <th mat-header-cell *matHeaderCellDef> Kennzeichen erkannt </th>
        <td mat-cell *matCellDef="let element"> {{element.contentDetected ? 'Ja' : 'Nein'}} </td>
    </ng-container>
    <ng-container matColumnDef="displayTriggered">
        <th mat-header-cell *matHeaderCellDef> Anzeige aktiviert (von) </th>
        <td mat-cell *matCellDef="let element"> {{element.displayTriggered | date: 'dd.MM.yyyy - H:mm:ss' }} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>